import React, { useState, useEffect, useRef} from "react";
import { Card, Button, Collapse } from 'react-bootstrap';
import { FaPaperPlane,} from "react-icons/fa";
import { Image as ImageIcon, FileText } from "lucide-react";
import EmojiPicker from "emoji-picker-react";
import { MentionsInput, Mention } from "react-mentions";
import PostActionBar from "../PostActionBar";
import { useLocation } from "react-router-dom";
import Auth from '../utils/auth';


function Submit({ user }) {
 const userProfile = Auth.loggedIn() ? Auth.getProfile() : null;
const currentUserId = userProfile?.userId;
  const [isLoaded, setIsLoaded] = useState(false);
// console.log("Current user ID:", currentUserId);
const [error, setError] = useState("");





//  console.log("User profile:", userProfile);
 const [openPosts, setOpenPosts] = useState({});
 const [showCreatePost, setShowCreatePost] = useState(false);
 const [visibleReplies, setVisibleReplies] = useState({});
const [replyForms, setReplyForms] = useState({}); // { [id]: { open: boolean, text: string } }
const [mentionNotifications, setMentionNotifications] = useState([]);
const [visibleCount, setVisibleCount] = useState(3);
const [showEmojiPickers, setShowEmojiPickers] = useState({});

// Visibility for each picker
const [showCreatePostPicker, setShowCreatePostPicker] = useState(false);
const [showCommentPickers, setShowCommentPickers] = useState({});
const [showReplyPickers, setShowReplyPickers] = useState({});
const [showNestedReplyPickers, setShowNestedReplyPickers] = useState({});

// Visibility for each edit picker
const [showEditPostPicker, setShowEditPostPicker] = useState(false);
const [showEditCommentPicker, setShowEditCommentPicker] = useState(false);
const [showEditNestedReplyPickers, setShowEditNestedReplyPickers] = useState({});


// Refs for inputs (to keep focus after emoji selection)
const createPostInputRef = useRef(null);
const commentInputRefs = useRef({});
const replyInputRefs = useRef({});
const nestedReplyInputRefs = useRef({});

const createPostPickerRef = useRef(null);
const commentPickerRefs = useRef({});
const replyPickerRefs = useRef({});
const nestedReplyPickerRefs = useRef({});

// Refs for edit inputs (to keep focus after emoji selection)
const editPostInputRef = useRef(null);
const editCommentInputRef = useRef({});
const editNestedReplyInputRefs = useRef({});

const editPostPickerRef = useRef(null);
const editCommentPickerRef = useRef(null);
const editNestedReplyPickerRefs = useRef({});

const normalizePostsResponse = (data) => {
  if (Array.isArray(data)) return data;       // backward compatibility
  if (Array.isArray(data.posts)) return data.posts;
  return [];
};
 const MAX_DEPTH = 3; // max indentation levels


const [nextCursor, setNextCursor] = useState(null);

const loadingRef = useRef(false); // ✅ Ref lock

// Flag to indicate whether we're in "My Posts" mode
const [isMyPostsMode, setIsMyPostsMode] = useState(false);


const fetchPosts = async (cursor = null, overrideMode = null) => {

  if (loadingRef.current) return; // prevent double fetch
  loadingRef.current = true;

  // Base URL
  let url = "https://bkf.onrender.com/posts";
  const mode = overrideMode !== null ? overrideMode : isMyPostsMode;


  // If fetching "My Posts", include userId
  if (mode && userProfile?.userId) {
    url += `?userId=${encodeURIComponent(userProfile.userId)}`;
    if (cursor) url += `&cursor=${encodeURIComponent(cursor)}`;
   

  } else if (cursor) {
    url += `?cursor=${encodeURIComponent(cursor)}`;
  }

  try {
    const res = await fetch(url);
    const data = await res.json();
    const newPosts = normalizePostsResponse(data.posts || []);

 setPosts(prev => {
  if (!cursor) return newPosts; // fresh load, replace everything

  const existingIds = new Set(prev.map(p => p.postId));
  const filteredNewPosts = newPosts.filter(p => !existingIds.has(p.postId));
  return [...prev, ...filteredNewPosts];
});


    setIsLoaded(true);
    setNextCursor(data.nextCursor || null);
  } catch (err) {
    console.error("Failed to fetch posts:", err);
  } finally {
    loadingRef.current = false;
    setPostsLoaded(true);
  }
};

const handleTogglePosts = () => {
  if (!userProfile?.userId) return;

  const newMode = !isMyPostsMode;

  setIsMyPostsMode(newMode);
  setNextCursor(null);
  setPosts([]); // important to avoid merge issues
  setIsLoaded(false); 
  fetchPosts(null, newMode); // pass mode explicitly
};




const ignoreScrollRef = useRef(false);

const prevScrollYRef = useRef(0);

useEffect(() => {
  prevScrollYRef.current = window.scrollY; // initialize once

  const handleScroll = () => {
    if (ignoreScrollRef.current || loadingRef.current || !nextCursor) return;

    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > prevScrollYRef.current;

    const isNearBottom =
      window.innerHeight + currentScrollY >=
      document.documentElement.scrollHeight - 10;

    if (isScrollingDown && isNearBottom) {
      fetchPosts(nextCursor);
    }

    prevScrollYRef.current = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [nextCursor]);



// Initial load
useEffect(() => {
  if (!userProfile?.userId) return;
  fetchPosts();
}, [userProfile?.userId]);

const LINK_REGEX =
  /(@\[[^\]]+\]\([^)]+\))|(https?:\/\/[^\s]+|www\.[^\s]+)/g;


useEffect(() => {
  const handleClickOutside = (e) => {
    // CREATE POST
    if (
      showCreatePostPicker &&
      createPostPickerRef.current &&
      !createPostPickerRef.current.contains(e.target)
    ) {
      setShowCreatePostPicker(false);
    }

       // ✏️ EDIT POST  ← ADD THIS BLOCK
    if (
      showEditPostPicker &&
      editPostPickerRef.current &&
      !editPostPickerRef.current.contains(e.target)
    ) {
      setShowEditPostPicker(false);
    }

    // COMMENTS
    setShowCommentPickers(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(id => {
        const ref = commentPickerRefs.current[id];
        if (ref && !ref.contains(e.target)) {
          next[id] = false;
        }
      });
      return next;
    });

    // REPLIES
    setShowReplyPickers(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(id => {
        const ref = replyPickerRefs.current[id];
        if (ref && !ref.contains(e.target)) {
          next[id] = false;
        }
      });
      return next;
    });

    // NESTED REPLIES
    setShowNestedReplyPickers(prev => {
      const next = { ...prev };
      Object.keys(next).forEach(id => {
        const ref = nestedReplyPickerRefs.current[id];
        if (ref && !ref.contains(e.target)) {
          next[id] = false;
        }
      });
      return next;
    });
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [
  showCreatePostPicker,
  showCommentPickers,
  showReplyPickers,
  showNestedReplyPickers,
]);


useEffect(() => {
  const adjustPicker = () => {
    document.querySelectorAll(".emoji-picker-popover").forEach(picker => {
      const rect = picker.getBoundingClientRect();

      if (window.innerWidth > 600 && rect.bottom > window.innerHeight - 20) {
        picker.classList.add("flip"); // optional: only flips based on window size
      } else {
        picker.classList.remove("flip");
      }
    });
  };

  // Initial adjustment
  adjustPicker();

  // Only listen for window resize
  window.addEventListener("resize", adjustPicker);

  return () => {
    window.removeEventListener("resize", adjustPicker);
  };
}, []); // empty dependencies → won't react to scroll, clicks, or input changes




const emojiRefs = useRef({});

  const location = useLocation();
  const { scrollToPostId } = location.state || {};
const didScrollRef = useRef(false);
  // Assuming posts are fetched with a useState like: const [posts, setPosts] = useState([]);
  const [postsLoaded, setPostsLoaded] = useState(false);



 useEffect(() => {
  if (!postsLoaded || !scrollToPostId || didScrollRef.current) return;

  // Scroll to post
  const el = document.getElementById(`post-${scrollToPostId}`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    el.style.transition = "background-color 0.6s ease";
    el.style.backgroundColor = "rgb(35, 30, 30)";
    setTimeout(() => (el.style.backgroundColor = ""), 1200);
    didScrollRef.current = true;

    // Clear location state so refresh won't scroll
    window.history.replaceState({}, document.title);
  }
}, [postsLoaded, scrollToPostId]);



const toggleReply = (id) => {
  setReplyForms(prev => ({
    ...prev,
    [id]: { ...(prev[id] || {}), open: !prev[id]?.open, text: prev[id]?.text || "" }
  }));
};

const toggleReplies = (id) => {
  setVisibleReplies(prev => ({
    ...prev,
    [id]: !prev[id]
  }));
};



const handleReplyChange = (id, text) => {
  setReplyForms(prev => ({
    ...prev,
    [id]: { ...(prev[id] || {}), text, open: true }
  }));
};

const [replyErrors, setReplyErrors] = useState({});
const [replySubmitting, setReplySubmitting] = useState({});

const handleSubmitReply = async (postId, parentId) => {
    const text = replyForms[parentId]?.text || "";

  // clear previous error
  setReplyErrors(prev => ({ ...prev, [parentId]: "" }));

  // validation (same pattern as comments/posts)
  if (!text.trim()) {
    setReplyErrors(prev => ({
      ...prev,
      [parentId]: "Enter a reply",
    }));
    return;
  }

  // prevent duplicate submits
  if (replySubmitting[parentId]) return;

  setReplySubmitting(prev => ({ ...prev, [parentId]: true }));

  try {
    const res = await fetch(
      `https://bkf.onrender.com/posts/${postId}/comments/${parentId}/replies`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: userProfile.userId, content: text }), // <-- changed
      }
    );
    if (!res.ok) throw new Error("Failed to send reply");
    const updatedPost = await res.json();
    
    setPosts(prev => 
      prev.map(p => (p.postId === updatedPost.postId ? updatedPost : p))
    );

     setVisibleReplies(prev => ({
    ...prev,
    [parentId]: true,
  }));

   setReplyForms(prev => ({ 
    ...prev, 
    [parentId]: { open: false, text: "" } }));

    

  } catch (err) {
    console.error("Error posting reply:", err);
  } finally {
    setReplySubmitting(prev => ({
      ...prev,
      [parentId]: false,
    }));
  }

};


 const [postForm, setPostForm] = useState({
  userId: user?.userId || "", 
  title: "",
  content: "",
  image: null,
  doc: null,
});

const [commentForms, setCommentForms] = useState({});


const [posts, setPosts] = useState([]);

// useEffect(() => {
//   if (!userProfile?.userId) return;

//   const fetchPosts = async () => {
//     try {
//       const postRes = await fetch("http://localhost:3003/posts");
//       const postData = await postRes.json();
//       const postsArray = Array.isArray(postData) ? postData : [postData];
//       setPosts(postsArray);
//     } catch (err) {
//       console.error("Failed to fetch posts:", err);
//     }
//   };

//   fetchPosts();
// }, [userProfile?.userId]);

// At the top of your component (Community.js)
const [preview, setPreview] = useState(null);

useEffect(() => {
  if (!postForm.image) {
    setPreview(null);
    return;
  }

  const objectUrl = URL.createObjectURL(postForm.image);
  setPreview(objectUrl);

  return () => URL.revokeObjectURL(objectUrl); // cleanup on unmount or when image changes
}, [postForm.image]);

useEffect(() => {
  if (!userProfile?.userId || posts.length === 0) return;

  const fetchNotifications = async () => {
    try {
      const notifRes = await fetch(
        `https://bkf.onrender.com/notifications/${userProfile.userId}`
      );
      const notifData = await notifRes.json();
      const notifications = notifData.notifications || [];

      const enrichedNotifications = notifications.map((n) => {
        const post = posts.find((p) => p.postId === n.postId);
        const snippet = n.snippet || n.message || "";
        const mentionMatch = snippet.match(/@(\w+)/);
        const mentionedBy = mentionMatch ? mentionMatch[1] : "";

        return {
          ...n,
          postId: n.postId,
          commentId: n.commentId || null,
          replyId: n.replyId || null,
          snippet,
          title: n.title || (post ? post.title : ""),
          mentionedBy,
          notificationId: n.notificationId,
          createdAt: n.createdAt,
        };
      });

      setMentionNotifications(enrichedNotifications);
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };

  fetchNotifications();
}, [userProfile?.userId, posts]);





  const handlePostChange = (e) => {
    setPostForm({ ...postForm, [e.target.name]: e.target.value });
  };

const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmitPost = async (e) => {
  e.preventDefault();

  setError(""); // clear old errors

if (!postForm.title.trim()) {
  setError("Enter a title");
  return;
}

if (!postForm.content.trim() && !postForm.image) {
  setError("Enter a message or upload an image");
  return;
}

   if (isSubmitting) return;
  if (!userProfile || !userProfile.userId) return console.error("User not logged in");

    setIsSubmitting(true);
  try {
    const formData = new FormData();
    formData.append("userId", userProfile.userId);
    formData.append("title", postForm.title);
    formData.append("content", postForm.content);
    if (postForm.image) formData.append("image", postForm.image);
    if (postForm.doc) formData.append("doc", postForm.doc);

    const res = await fetch("https://bkf.onrender.com/posts", {
      method: "POST",
      body: formData, // multipart/form-data
    });

    if (res.ok) {
      const newPost = await res.json();
      setPosts(prev => [...prev, newPost]);
      setPostForm({ 
        title: "", 
        content: "", 
        userId: userProfile.userId, 
        image: null, doc: 
        null });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setIsSubmitting(false); // 🔓 unlock no matter what
  }
};

const [editingPostId, setEditingPostId] = useState(null);
const [editForm, setEditForm] = useState(null);

const startEditPost = (post) => {
  setEditingPostId(post.postId);

  setEditForm({
    title: post.title || "",
    content: post.content || "",
    image: null,
    existingImage: post.image || "",
    removeImage: false,
    doc: null,
    existingDoc: post.doc || "",
    removeDoc: false,
  });
};



const handleUpdatePost = async (e, postId) => {
  e.preventDefault();

  try {
    const formData = new FormData();
    formData.append("title", editForm.title);
    formData.append("content", editForm.content);

    if (editForm.image) {
      formData.append("image", editForm.image);
    }

    if (editForm.removeImage) {
      formData.append("removeImage", "true");
    }

    if (editForm.doc) {
      formData.append("doc", editForm.doc);
    }

    if (editForm.removeDoc) {
      formData.append("removeDoc", "true");
    }

    const res = await fetch(`https://bkf.onrender.com/posts/${postId}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${Auth.getToken()}`,
        // 🚫 DO NOT set Content-Type
      },
      body: formData,
    });

    if (!res.ok) throw new Error("Failed to update post");

    const updatedPost = await res.json();

    setPosts((prev) =>
      prev.map((p) => (p.postId === postId ? updatedPost : p))
    );

    setEditingPostId(null);
  } catch (err) {
    console.error("Error updating post:", err);
  }
};

const [editingCommentId, setEditingCommentId] = useState(null);
const [editCommentForm, setEditCommentForm] = useState({});

const startEditComment = (comment) => {
  setEditingCommentId(comment.commentId);
  setEditCommentForm({
    comment: comment.comment || comment.content || "",
  });
};


const handleUpdateComment = async (e, postId, commentId) => {
  e.preventDefault();

  try {
    const res = await fetch(
      `https://bkf.onrender.com/posts/${postId}/comments/${commentId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          comment: editCommentForm.comment,
        }),
      }
    );

    if (!res.ok) throw new Error("Failed to update comment");

    const updatedPost = await res.json();

    // Update the whole post in your posts state
    setPosts((prev) =>
      prev.map((p) => (p.postId === postId ? updatedPost : p))
    );

    setEditingCommentId(null);
  } catch (err) {
    console.error(err);
  }
};


const [commentErrors, setCommentErrors] = useState({});
const [commentSubmitting, setCommentSubmitting] = useState({});

const handleSubmitComment = async (postId) => {
  const comment = commentForms[postId]?.comment || "";
    // clear previous error
  setCommentErrors(prev => ({ ...prev, [postId]: "" }));

  // ✅ better validation (matches your post logic style)
  if (!comment.trim()) {
    setCommentErrors(prev => ({
      ...prev,
      [postId]: "Enter a comment",
    }));
    return;
  }

  // 🚫 prevent duplicate submits
  if (commentSubmitting[postId]) return;

  setCommentSubmitting(prev => ({ ...prev, [postId]: true }));

  try {
    const res = await fetch(
      `https://bkf.onrender.com/posts/${postId}/comments`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: userProfile.userId, comment }),
      }
    );

    if (res.ok) {
      const updatedPost = await res.json();
      setPosts((prev) =>
        prev.map((p) => (p.postId === postId ? updatedPost : p))
      );
      setCommentForms((prev) => ({
        ...prev,
        [postId]: { comment: "" },
      }));
    }
  } catch (err) {
    console.error(err);
  } finally {
    setCommentSubmitting(prev => ({
      ...prev,
      [postId]: false,
    }));
  }
};
  const [usersList, setUsersList] = useState([]);

  
const [editingReply, setEditingReply] = useState(null);
// { replyId, parentReplyId | null }

const [editReplyForm, setEditReplyForm] = useState({});

const startEditReply = (reply) => {
  setEditingReply({
    replyId: reply.replyId,
    parentReplyId: null,
  });
  setEditReplyForm({ content: reply.content });
};





const handleUpdateReply = async (
  e,
  postId,
  commentId,
  replyId,
  parentReplyId = null
) => {
  e.preventDefault();

  const res = await fetch(
    `https://bkf.onrender.com/posts/${postId}/comments/${commentId}/replies/${replyId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        content: editReplyForm.content,
        parentReplyId, // 🔑 KEY
      }),
    }
  );

  if (!res.ok) throw new Error("Failed to update reply");

  const updatedPost = await res.json();
  setPosts(prev => prev.map(p => p.postId === postId ? updatedPost : p));
  setEditingReply(null);
};




useEffect(() => {
  const fetchCrewMembers = async () => {
    try {
      const res = await fetch("https://bkf.onrender.com/investors");
      const data = await res.json();
      // Map the crew members to a format the Mentions component expects
     setUsersList(
  data.map(u => ({
    id: u.userId,         // internal unique identifier for backend
    display: u.crewmember  // what user actually sees
  }))
);

    } catch (err) {
      console.error("Fetch crew members failed:", err);
    }
  };
  fetchCrewMembers();
}, []);

// Automatically close emoji pickers when clicking outside
useEffect(() => {
  Object.keys(emojiRefs.current).forEach((id) => {
    const ref = { current: emojiRefs.current[id] };
    if (!ref.current) return;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowEmojiPickers((prev) => ({ ...prev, [id]: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
}, [showEmojiPickers]); // rerun when any picker opens/closes

// Right after your other handler functions, before return:

const handleReact = async (postId, reaction) => {
  setPosts((prev) =>
    prev.map((p) =>
      p.postId === postId
        ? {
            ...p,
            userReaction: reaction,
            reactionCounts: {
              ...p.reactionCounts,
              [reaction]: (p.reactionCounts?.[reaction] || 0) + 1,
            },
          }
        : p
    )
  );

  try {
    const res = await fetch(`https://bkf.onrender.com/posts/${postId}/reactions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: userProfile.userId, reaction }),
    });
    const updatedPost = await res.json();

   setPosts(prev =>
  prev.map(p => {
    if (p.postId !== postId) return p;

    const currentCount = p.reactions?.[reaction] || 0;
    return {
      ...p,
      userReaction: reaction,
      reactions: { ...p.reactions, [reaction]: currentCount + 1 },
    };
  })
);
  } catch (err) {
    console.error("Failed to save reaction:", err);
  }
};

const openCommentsHandler = (postId) => {
  // toggle comments open/closed for a post
  setOpenPosts((prev) => ({
    ...prev,
    [postId]: !prev[postId],
  }));
};

const shareHandler = (postId) => {
  console.log("Share clicked for post:", postId);
  // Implement your share logic here
};

const createPostRef = useRef(null);

useEffect(() => {
  if (!showCreatePost) return;

  const handleClickOutside = (e) => {
    if (
      createPostRef.current &&
      !createPostRef.current.contains(e.target)
    ) {
      setShowCreatePost(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showCreatePost]);




function facebookTime(date) {
  const now = new Date();
  const postDate = new Date(date);

  const diffSeconds = Math.floor((now - postDate) / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffSeconds / 3600);

  const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };
  const optionsMonthDay = { month: "short", day: "numeric" };
  const optionsMonthDayYear = { month: "short", day: "numeric", year: "numeric" };

  if (diffMinutes < 1) return "just now";
  if (diffMinutes < 60) return `${diffMinutes}m`;
  if (diffHours < 24) return `${diffHours}h`;

  // ✅ Calendar-based "Yesterday"
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  const isYesterday =
    postDate.getDate() === yesterday.getDate() &&
    postDate.getMonth() === yesterday.getMonth() &&
    postDate.getFullYear() === yesterday.getFullYear();

  if (isYesterday) {
    return `Yesterday at ${postDate.toLocaleTimeString(undefined, optionsTime)}`;
  }

  // Same year
  if (now.getFullYear() === postDate.getFullYear()) {
    return `${postDate.toLocaleDateString(undefined, optionsMonthDay)} at ${postDate.toLocaleTimeString(undefined, optionsTime)}`;
  }

  return `${postDate.toLocaleDateString(undefined, optionsMonthDayYear)} at ${postDate.toLocaleTimeString(undefined, optionsTime)}`;
}

const [searchTerm, setSearchTerm] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [highlightedIndex, setHighlightedIndex] = useState(-1);

const handleSearchChange = async (e) => {
  const term = e.target.value;
  setSearchTerm(term);
  setHighlightedIndex(-1);

  if (term.trim() === "") {
    setSearchResults([]);
    return;
  }

  try {
    const res = await fetch(
      `https://bkf.onrender.com/posts/search?term=${encodeURIComponent(term)}`
    );
    const data = await res.json();
    console.log("Search results received:", data);
    setSearchResults(data.posts || []);  // <-- only set the posts array
  } catch (err) {
    console.error("Search failed:", err);
    setSearchResults([]);
  }
};

const handleSearchKeyDown = (e) => {
  if (searchResults.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    setHighlightedIndex(prev => (prev + 1) % searchResults.length);
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    setHighlightedIndex(prev => (prev - 1 + searchResults.length) % searchResults.length);
  } else if (e.key === "Enter") {
    e.preventDefault();
    if (highlightedIndex >= 0) {
      handleResultClick(searchResults[highlightedIndex].postId);
    }
  }
};

const formatMentions = (text) => {
  if (!text) return text;
  return text.replace(/@\[(.+?)\]\([^)]+\)/g, '@$1');
};





const handleResultClick = async (postId) => {
  const existing = posts.find(p => p.postId === postId);

  if (!existing) {
    try {
      const res = await fetch(`https://bkf.onrender.com/posts/${postId}`);
      if (!res.ok) throw new Error('Failed to fetch post');
      const post = await res.json();
      setPosts(prev => [post, ...prev]);
    } catch (err) {
      console.error(err);
      return;
    }
  }

  const waitForScrollToFinish = () => {
    return new Promise(resolve => {
      let scrollTimeout;

      const onScroll = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          window.removeEventListener("scroll", onScroll);
          resolve();
        }, 150);
      };

      window.addEventListener("scroll", onScroll);
    });
  };

  ignoreScrollRef.current = true;

  // Wait for DOM render
  setTimeout(async () => {
    const el = document.getElementById(`post-${postId}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });

      el.style.transition = "background-color 0.6s ease";
      el.style.backgroundColor = "rgb(35, 30, 30)";
      setTimeout(() => (el.style.backgroundColor = ""), 1200);
    }

    // ✅ THIS was missing
    await waitForScrollToFinish();

    // ✅ Re-enable infinite scroll
    ignoreScrollRef.current = false;

  }, 100);

  setSearchTerm("");
  setSearchResults([]);
};


// Helper to highlight matched text
const highlightMatch = (text) => {
  if (!searchTerm) return text;
  const regex = new RegExp(`(${searchTerm})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) =>
    regex.test(part) ? (
      <span key={i} style={{ backgroundColor: "yellow", color: "black" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};










  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  // Tracks which posts are expanded
const [expandedPosts, setExpandedPosts] = useState({});

// Tracks which posts overflow 5 lines
const [overflowingPosts, setOverflowingPosts] = useState({});

// Refs for each post's paragraph
const contentRefs = useRef({});

useEffect(() => {
  const newOverflowing = {};
  posts.forEach((post) => {
    const el = contentRefs.current[post.postId];
    if (el) {
      // Check if content is taller than 5 lines
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const maxHeight = lineHeight * 5; // 5 lines
      newOverflowing[post.postId] = el.scrollHeight > maxHeight + 1;
    }
  });
  setOverflowingPosts(newOverflowing);
}, [posts]);

const handleTogglePin = async (postId) => {
  try {
    const res = await fetch(
      `https://bkf.onrender.com/posts/${postId}/pin`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.ok) throw new Error("Failed to pin");

    // Refresh feed (simplest + safest way for infinite scroll)
    window.location.reload();

  } catch (err) {
    console.error("Pin error:", err);
  }
};

const toggleBold = (setContent, inputRef) => {
  const textarea = inputRef.current;
  if (!textarea) return;

  const content = textarea.value;

  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  if (start === end) return;

  const selectedText = content.slice(start, end);

  const before = content.slice(0, start);
  const after = content.slice(end);

  const isWrapped =
    content.slice(start - 2, start) === "**" &&
    content.slice(end, end + 2) === "**";

  let newContent;

  if (isWrapped) {
    newContent =
      content.slice(0, start - 2) +
      content.slice(start, end) +
      content.slice(end + 2);
  } else {
    newContent =
      before + `**${selectedText}**` + after;
  }

  setContent(prev => ({
    ...prev,
    content: newContent,
  }));

  setTimeout(() => {
    textarea.focus();

    const cursorPos = isWrapped ? start - 2 : end + 2;

    textarea.setSelectionRange(cursorPos, cursorPos);
  }, 50);
};

const toggleLink = (setContent, inputRef) => {
  const textarea = inputRef.current;
  if (!textarea) return;

  const content = textarea.value;

  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  if (start === end) return;

  const selectedText = content.slice(start, end);

  const url = window.prompt("Enter URL:");

  if (!url) return;

  const before = content.slice(0, start);
  const after = content.slice(end);

  const markdownLink = `[${selectedText}](${url})`;

  setContent(prev => ({
    ...prev,
    content: before + markdownLink + after,
  }));

  setTimeout(() => {
    textarea.focus();
  }, 50);
};

// 🔹 Italics toggle function
// const toggleItalic = (setEditForm, inputRef) => {
//   const input = inputRef.current;
//   const start = input.selectionStart;
//   const end = input.selectionEnd;
//   const selectedText = input.value.slice(start, end);

//   // Wrap selection with * for italics
//   const newText =
//     input.value.slice(0, start) + `*${selectedText}*` + input.value.slice(end);

//   setEditForm((prev) => ({ ...prev, content: newText }));

//   // Keep selection inside italics
//   input.focus();
//   input.setSelectionRange(start + 1, end + 1);
// };






  return (
    <>
       <div
       style={{
          marginTop: '10%'
        }}
       > 

          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
              >
                <source 
                // src={BG} type="video/mp4" 
                 src={`${CF_BASE}/public/backgroundgrey2.mp4`} 
                />
                Your browser does not support the video tag.
            </video>
       <h1 className="justify-content-center"
       style={{
        // marginTop: '50px',
       WebkitTextStroke: '2px rgb(243, 174, 61)', // <-- outline around letters
            color: 'black', }}
       > 
       Investor Forum</h1>
            </div>
             <Card 
            style={{
              margin: '3%',
              width: 'auto',
              height: 'auto',
              boxSizing: 'border-box',
              }}>
          {mentionNotifications.length > 0 &&
            [...mentionNotifications]
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .slice(0, visibleCount)
              .map((m) => {
                // destructure so commentId / replyId are defined variables
                const {
                  notificationId,
                  snippet,
                  mentionedBy,
                } = m;

                // extract raw postId from notification
                let postId = m.postId || m.link?.split("/posts/")[1];

                // FIX: remove '#comment-...' or any fragment
                if (postId && postId.includes("#")) {
                  console.log("Fixing broken postId. Original:", postId);
                  postId = postId.split("#")[0];
                  console.log("Clean postId:", postId);
                }


            
              const getTwitterStylePreview = (text, username, maxLength = 90) => {
                if (!text) return "";

                if (!username) {
                  return text.length > maxLength
                    ? text.slice(0, maxLength) + "…"
                    : text;
                }

                const mention = `@${username}`;
                const index = text.indexOf(mention);

                if (index === -1) {
                  return text.length > maxLength
                    ? text.slice(0, maxLength) + "…"
                    : text;
                }

                const half = Math.floor(maxLength / 2);

                let start = Math.max(0, index - half);
                let end = start + maxLength;

                if (end > text.length) {
                  end = text.length;
                  start = Math.max(0, end - maxLength);
                }

                return (start > 0 ? "…" : "") +
                      text.slice(start, end) +
                      (end < text.length ? "…" : "");
              };

              const escapeRegex = str =>
                str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

              const cleanMentionedBy = mentionedBy?.startsWith("@")
                ? mentionedBy.slice(1)
                : mentionedBy;

              const previewText = getTwitterStylePreview(snippet, cleanMentionedBy);

              const highlightedSnippet = previewText
                .split(new RegExp(`(@${escapeRegex(cleanMentionedBy || "")})`, "g"))
                .map((part, i) =>
                  part === `@${cleanMentionedBy}` ? (
                    <span key={i} className="name-mention">{part}</span>
                  ) : (
                    part
                  )
                );


                //  const highlightedSnippet = (snippet || "")
                //   .split(new RegExp(`(@${mentionedBy || ""})`, "g"))
                //   .map((part, i) =>
                //     part === `@${mentionedBy}` ? (
                //       <span key={i} className="name-mention">{part}</span>
                //     ) : (
                //       part
                //     )
                //   );



            const handleNotificationClick = async (notif) => {
              console.log("Notification clicked:", notif);

              // 1️⃣ Extract postId from notif or link
              let { postId: rawPostId, notificationId, createdAt } = notif;
              let commentId = null;
              let replyId = null;

              let postId = rawPostId;
              if (!postId && notif.link) {
                postId = notif.link.split("/posts/")[1]?.split("#")[0];
              }
              console.log("Extracted postId from link:", postId);

              // 2️⃣ Extract commentId and replyId from link if not provided
              if (!notif.commentId && notif.link) {
                const match = notif.link.match(/#comment-([a-z0-9-]{36})(?:-reply-([a-z0-9-]{36}))?/i);
                if (match) {
                  const [, extractedCommentId, extractedReplyId] = match;
                  console.log("Extracted from link:", extractedCommentId, extractedReplyId);
                  commentId = extractedCommentId;
                  replyId = extractedReplyId;
                }
              } else {
                commentId = notif.commentId;
                replyId = notif.replyId;
              }

              console.log("Final commentId / replyId:", commentId, replyId);

              ignoreScrollRef.current = true;

  // 1️⃣ Ensure post exists (same pattern as your search)
  let postObj = posts.find(p => p.postId === postId);

  if (!postObj) {
    try {
      const res = await fetch(`https://bkf.onrender.com/posts/${postId}`);
      if (!res.ok) throw new Error("Failed to fetch post");

      postObj = await res.json();
      setPosts(prev => [postObj, ...prev]);
    } catch (err) {
      console.error(err);
      ignoreScrollRef.current = false;
      return;
    }
  }

              
            // 5️⃣ Open replies as needed
            setTimeout(() => {
              if (commentId || replyId) {
                // Find top-level comment and path to target reply
                setOpenPosts(prev => ({ ...prev, [postId]: true }));
                const findTopCommentAndPath = (comments, targetReplyId) => {
                  for (const c of comments) {
                    // If target is top-level comment
                    if (c.commentId === targetReplyId) return { topComment: c, path: [] };

                    const findInReplies = (replies, path = []) => {
                      if (!replies) return null;
                      for (const r of replies) {
                        if (r.replyId === targetReplyId) return { topComment: c, path: [...path, r.replyId] };
                        const deeper = findInReplies(r.replies, [...path, r.replyId]);
                        if (deeper) return deeper;
                      }
                      return null;
                    };

                    const result = findInReplies(c.replies);
                    if (result) return result;
                  }
                  return null;
                };

                let topComment, toOpen = [];

                if (replyId) {
                  const result = findTopCommentAndPath(postObj.comments, replyId);
                  if (!result) return console.error("Top-level comment not found for nested reply:", replyId);
                  topComment = result.topComment;
                  toOpen = [topComment.commentId, ...result.path];
                } else if (commentId) {
                  topComment = postObj.comments.find(c => c.commentId === commentId);
                  if (!topComment) return console.error("Top-level comment not found:", commentId);
                  toOpen = [commentId];
                }

                console.log("Final toOpen list (all ancestors):", toOpen);

                // Open all necessary replies
                setVisibleReplies(prev => {
                  const updated = { ...prev };
                  toOpen.forEach(id => {
                    updated[id] = true;
                    console.log("Opening reply/comment ID:", id);
                  });
                  return updated;
                });

                // 6️⃣ Scroll & highlight (inner setTimeout)
                setTimeout(() => {
                  const elementId = `post-${postId}-comment-${topComment.commentId}` + (replyId ? `-reply-${replyId}` : '');
                  console.log("Trying to scroll to elementId:", elementId);
                  const el = document.getElementById(elementId);
                  if (el) {
                    console.log("Element found, scrolling now:", el);
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    el.style.transition = "background-color 0.6s ease";
                    el.style.backgroundColor = "rgb(35, 30, 30)";
                    setTimeout(() => (el.style.backgroundColor = ""), 1200);
                  } else {
                    console.warn("Element not found:", elementId);
                  }
                }, 100);
            } else {
                // Post-only notification: just scroll & highlight
                setTimeout(() => {
                  const elementId = `post-${postId}`;
                  console.log("Trying to scroll to post elementId:", elementId);
                  const el = document.getElementById(elementId);
                  if (el) {
                    console.log("Post element found, scrolling now:", el);
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    el.style.transition = "background-color 0.6s ease";
                    el.style.backgroundColor = "rgb(35, 30, 30)";
                    setTimeout(() => (el.style.backgroundColor = ""), 1200);
                  } else {
                    console.warn("Post element not found:", elementId);
                  }
                }, 100);
              }

            }, 100);


              // 7️⃣ Remove notification locally
              setMentionNotifications(prev =>
                prev.filter(n => n.notificationId !== notificationId)
              );
              console.log("Removed notification locally:", notificationId);

              // 8️⃣ Delete notification from backend
              try {
                const res = await fetch(
                  `https://bkf.onrender.com/notifications/${userProfile.userId}/${encodeURIComponent(createdAt)}`,
                  { method: "DELETE" }
                );
                if (!res.ok) console.error("Server failed to delete notification", res.status);
              } catch (err) {
                console.error("Failed to delete notification:", err);
              }
            };

      return (
        <Card
          key={notificationId}
          className=" mb-2"
          style={{ 
            display: "flex", 
             maxWidth: "400px",
             margin: "0 auto", 
            justifyContent: 'center', 
            
          }}
        >
          <Button
            onClick={() => handleNotificationClick(m)} // ✅ Pass the notification object
            className="hover-brighten"
            style={{ 
              backgroundColor: "rgba(20,19,19,0.9)", 
              color: 'silver', 
              border: "none",  
              cursor: "pointer" }}
          >
          <p 
          style={{ 
              margin: 0,}}
          >
             {highlightedSnippet}
          </p>
          </Button>
        </Card>
      );
    })}

    {/* 👇 SEE MORE BUTTON */}
      {mentionNotifications.length > visibleCount && (
        <>
      <div
          style={{ 
              display: "flex", 
             maxWidth: "400px",
             margin: "0 auto", 
            justifyContent: 'center', 
            
          }}
          >
        <Button className="hover-brighten "
          onClick={() => setVisibleCount(prev => prev + 3)}
          style={{ 
            background: "none", 
            border: "none", 
            color: "silver", 
            cursor: "pointer",
          fontWeight: "bold",  }}
        >
            <p 
          style={{ 
              margin: 0,}}
          >
            see more
            </p>
         
        </Button>
      </div>
        </>


      )}

       </Card>

      <div style={{marginBottom: '7%' }}>
      <div
      className="create-post-wrapper">

        {!showCreatePost && (
          <>

          <Card
          className='hover-brighten'
        style={{
          maxWidth: "200px",
          margin: "0 auto",
          marginBottom: "40px",
          textAlign: "center",
          padding: "0", // remove padding from Card to avoid clipping background


          position: 'relative', // for z-index control if needed
        }}
          >


        <button
          className="create-post-trigger"
        style={{
          fontWeight: "bold",
          color: "silver",
            display: "inline-block",
          // padding: "0.2rem 0.6rem",
          backgroundColor: 'rgba(20,19,19,0.9)',
          borderRadius: '12px',
          border: '2px solid rgb(179,37,25)',
          boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
        }}
          onClick={() => setShowCreatePost(true)}
        >
          <h2 className='d-flex justify-content-center'
          style={{
                margin: '1%',
              }}
          >
            Create a Post
          </h2>
          
        </button>
        </Card>
        </>
      )}



    {showCreatePost && (
          <Card ref={createPostRef} className={`card-body pt-4 px-4 pb-2 mb-5 create-post-card ${
        showCreatePost ? "open" : ""
      }`}
        style={{
          display: 'block',
          width: '95%',      
          maxWidth: '700px', 
          margin: '0 auto',  
          height: 'auto',
          boxSizing: 'border-box',
        }}>

        <h2>Create a Post</h2>
                  {error && (
        <div
          style={{
            color: "#ff4d4f",
            marginBottom: "10px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "clamp(12px, 1.8vmax, 18px)",
          }}
        >
          {error}
        </div>
      )}
        <form onSubmit={handleSubmitPost}>
          <div className="mb-2">
            <label>
              <h3>Subject</h3>
              </label>
            <input
              type="text"
              name="title"
              value={postForm.title}
              onChange={(e) => {
              handlePostChange(e);
              setError("");
            }}
              className="form-control custom-input"
              // required
              style ={{ 
              color: "silver",
              background: "rgb(35, 30, 30)",
              boxShadow: "0px 0px 8px silver",
              border: "none",
              outline: "none",
              }}
            />
          </div>
          <div className="mb-2">
            <label>
              <h3>Message</h3>
            </label>
 

          <MentionsInput
          inputRef={createPostInputRef}
          value={postForm.content}
          onChange={(e) => {
          setPostForm({ ...postForm, content: e.target.value });
          setError("");
        }}
         
          rows="4"
          placeholder="What's on your mind?"
          style={{
            control: {
              minHeight: 80,
              borderRadius: 8,
              outline: "none",
            },
            highlighter: {
              padding: 6,
              fontSize: 16,
              lineHeight: 1.4,
            },
            input: {
              padding: 6,
              fontSize: 16,
              lineHeight: 1.4,
              color: "silver",
              background: "rgb(35, 30, 30)",
              boxShadow: "0px 0px 8px silver",
              border: 'none',
              outline: "none",
            },
              suggestions: {
            list: {
              background: "rgb(35, 30, 30)",
              padding: 4,
              boxShadow: "0 0 8px rgba(255,255,255,0.3)",
              border: 'none',
              maxHeight: 200,      // <-- This limits the height of the dropdown
              overflowY: "auto",
              
            },
            item: {
              padding: "2px 6px",
              color: "white",
            },
          }
          }}
        >
         <Mention
          trigger="@"
          data={usersList}
          displayTransform={(id, display) => `@${display}`}
          renderSuggestion={(entry, search, focused) => {
            // Escape the HTML safely to avoid XSS
            const escapedDisplay = entry.display.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

            // Highlight the matching letters manually
            const regex = new RegExp(`(${search})`, "ig");
            const finalHTML = escapedDisplay.replace(
              regex, 
              `<span style="font-size: 16px;">$1</span>`);

            return (
              <div
                style={{
                  color: focused ? "silver" : "silver",
                  backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                  fontSize: 16,
                  lineHeight: "1.1em",
                  zIndex: 2000,
                }}
                // Render the highlighted letters correctly
                dangerouslySetInnerHTML={{ __html: finalHTML }}
              />
            );
          }}
        />

        </MentionsInput>
       
        <label style={{ alignItems: "center", gap: "8px", cursor: "pointer" }}>
          {/* Icon triggers the hidden file input */}
          <ImageIcon color="silver" size={24} />

          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
            setPostForm({ ...postForm, image: e.target.files[0] });
            setError("");
          }}
            style={{ display: "none" }} // hide the actual input
          />
        </label>
{/* 
        <label style={{ alignItems: "center", gap: "8px", cursor: "pointer" }}>
          <FileText color="silver" size={24} />

          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            onChange={(e) =>
              setPostForm(prev => ({
                ...prev,
                doc: e.target.files[0]
              }))
            }
            style={{ display: "none" }}
          />
        </label> */}
        
        {/* CREATE POST Emoji Picker */}
        <Button
          variant="none"
          size="m"
          onClick={() => setShowCreatePostPicker(prev => !prev)}
        >
          😀
        </Button>

        {showCreatePostPicker && (
          <div
            ref={createPostPickerRef}
            className="emoji-picker-popover"
          >
            <button
              type="button"                 
            className="hover-brighten"
            style={{
              position: "absolute",
              bottom: -1,
              right: -1,
              zIndex: 2000,
              background: "red",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px", 
            }}
              onClick={() => setShowCreatePostPicker(false)}
            >
            <b>Close</b>
            </button>

            <EmojiPicker
              variant="dark"
              onEmojiClick={(emojiData) => {
                setPostForm(prev => ({
                  ...prev,
                  content: prev.content + emojiData.emoji,
                }));
                createPostInputRef.current?.focus();
              }}
            />
          </div>
        )}
        {/* <Button
  type="button"
onClick={() =>
  toggleBold(setPostForm, createPostInputRef)
}
style={{ background: "none", border: "none", cursor: "pointer", fontSize: "clamp(1.2rem, 2vw, 1.8rem)",}}
>
  <b>B</b>
</Button>
<Button
  type="button"
  onClick={() => toggleLink(setPostForm, createPostInputRef)}
  style={{ background: "none", border: "none", cursor: "pointer" }}
>
  🔗
</Button> */}

             <button 
             type="submit" 
             className="send-button"
             disabled={isSubmitting} 
             style={{ 
              background: "none", 
              border: "none", 
              cursor: isSubmitting ? "not-allowed" : "pointer",
              opacity: isSubmitting ? 0.5 : 1,
              }}>
                  <FaPaperPlane className="send-icon" 
                  style={{ 
                    fontSize: "1.4rem", 
                    color: "white" }} />
                </button>
          </div>
            {preview && (
          <div style={{ 
            marginTop: "10px", 
            display: "flex",          // use flex to center horizontally
            justifyContent: "center", // center the content
            position: "relative"      // needed so X button is positioned relative to this container
          }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={preview}
                alt="Preview"
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  boxShadow: "0 0 8px silver",
                }}
              />
              {/* Remove / X button */}
              <button className="hover-brighten"
                onClick={() => {
                  setPostForm({ ...postForm, image: null });
                  setPreview(null);
                }}
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "24px",
                  height: "24px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>
          </div>
        )}
        {postForm.doc && (
          <p style={{ fontSize: "12px", color: "gray" }}>
            {postForm.doc.name}
          </p>
        )}
        </form>
      </Card>
      )}

      </div>
<Card 
     className='hover-brighten'
        style={{
          maxWidth: "200px",
          margin: "0 auto",
          marginBottom: "40px",
          textAlign: "center",
          padding: "0", // remove padding from Card to avoid clipping background


          position: 'relative', // for z-index control if needed
        }}
        >
  <button 
  style={{
          fontWeight: "bold",
          color: "silver",
            display: "inline-block",
          // padding: "0.2rem 0.6rem",
          backgroundColor: 'rgba(20,19,19,0.9)',
          borderRadius: '12px',
          border: '2px solid rgb(179,37,25)',
          boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
        }}
  onClick={handleTogglePosts}
>
    <h2 className='d-flex justify-content-center'
  style={{ margin: '1%' }} >
  {isMyPostsMode ? "All Posts" : "My Posts"}
</h2>

    </button>
</Card>


<Card 
// style={{ 
//   position: "relative", 
//   zIndex: -1 }}
  >
  <input className="pt-4 px-4 pb-2 mb-5 card-body" 
    type="text"
    value={searchTerm}
    onChange={handleSearchChange}
       onKeyDown={handleSearchKeyDown}
    placeholder="Search feed..."
     style={{
      display: 'block',
      width: '85%',      
      maxWidth: '700px',
      position: "relative" ,           
      height: "60px",         
      padding: "12px 16px",        
      borderRadius: "12px",
      border: "none",
      backgroundColor: "rgba(20,19,19,0.9)",
      margin: '0 auto',  
      color: "silver",
      outline: "none",
  }}
  />
  {searchResults.length > 0 && (
    <div
       style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translateX(-50%)",
      width: "85%",
      maxWidth: "800px",
      background: "rgb(35,30,30)",
      border: "1px solid rgba(0, 0, 0, 0.7)",
      boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.05)",

      borderRadius: "8px",
      zIndex: 1000,
      maxHeight: "300px",
      overflowY: "auto",
    }}
    >
      {searchResults.map((p) => (
        <div
          key={p.postId}
          onClick={() => handleResultClick(p.postId)}
          style={{
            padding: "8px",
            cursor: "pointer",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            color: "silver",
          }}
        >
           <div style={{ fontWeight: 'bold' }}>
            {highlightMatch(formatMentions(p.title))}
          </div>

          <div style={{ fontSize: '0.9rem', color: 'silver' }}>
            {highlightMatch(formatMentions(p.content).slice(0, 60))}...
          </div>
        </div>
      ))}
    </div>
  )}

</Card>

      {!isLoaded && (
  <div  style={{ 
                    // height:"100vh",
                    marginTop: "10%",
                    marginRight: "25%",
                    marginLeft: "25%" 
                    }}>
    <Card className="card-body" style={{ textAlign: "center" }}>
      <h1>Loading...</h1>
    </Card>
  </div>
)}

{isLoaded && posts.length === 0 && isMyPostsMode && (
  <div style={{
    // marginTop: "10%",
    marginRight: "25%",
    marginLeft: "25%"
  }}>
    <Card className="card-body" style={{ textAlign: "center" }}>
      <h1
      className='d-flex justify-content-center'
          style={{
                margin: '1%',
              }}
      >No Posts</h1>
    </Card>
  </div>
)}

{posts.map((post) => {
    const isOpen = openPosts[post.postId] || false;
    const isExpanded = expandedPosts[post.postId] || false;
const isOverflowing = overflowingPosts[post.postId] || false;

    const totalComments = Array.isArray(post.comments)
  ? post.comments.reduce(
      (sum, c) =>
        sum +
        1 + // the comment itself
        (Array.isArray(c.replies) ? c.replies.length : 0),
      0
    )
  : 0;
  


    return (
      <Card
        key={post.postId}
        className="card-body mb-3 p-1"
        style={{
          display: "block",
          marginRight: "10%",
          marginLeft: "10%",
          marginBottom: "5%",
            width: "90%", // or auto
            maxWidth: "700px",
            margin: "0 auto",
          height: "auto",
          boxSizing: "border-box",
        }}
      >
   <div 
   id={`post-${post.postId}`} 
    style={{
      cursor: "pointer",
      }}
          onClick={() =>
            setOpenPosts({ ...openPosts, [post.postId]: !isOpen })
          }>
      <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <img
        src={post.profileImage || "https://via.placeholder.com/50"}
        alt={post.postedBy || "Unknown User"}
        style={{ width: "50px", height: "50px", borderRadius: "50%" }}
      />
      
      {/* Name and time stacked vertically */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h4 style={{ margin: 0 }}>{post.postedBy || "Unknown User"}</h4>
        <p
          style={{
            fontSize: "0.9rem",
            color: "silver",
            
            
          }}
        >
          {facebookTime(post.createdAt)}
        </p>
      </div>
    </div>
    

{editingPostId === post.postId && editForm ? (
  /* ================= EDIT MODE ================= */
  <>
  {console.log("POST EDITOR RENDER")}

  <form
    onClick={(e) => e.stopPropagation()}
    onSubmit={(e) => handleUpdatePost(e, post.postId)}
     style={{
          display: 'block',
          width: '95%',      
          maxWidth: '700px', 
          margin: '0 auto',  
          height: 'auto',
          boxSizing: 'border-box',
        }}
  >
    <div className="mb-2">
      <label>
        <h3>Subject</h3>
      </label>
       <input
      value={editForm.title}
       onChange={(e) =>
    setEditForm(prev => ({
      ...prev,
      title: e.target.value
    }))
  }
      className="form-control custom-input"
       style ={{ 
      color: "silver",
      fontSize: "clamp(12px, 1.8vmax, 18px)",
      background: "rgb(35, 30, 30)",
      boxShadow: "0px 0px 8px silver",
      border: "none",
      outline: "none",
              }}
    />
    </div>
 

     <label>
              <h3>Message</h3>
            </label>

<MentionsInput
key={editingPostId} 
inputRef={editPostInputRef}
 value={editForm.content.replace(/\r\n/g, "\n")}
  onChange={(event, newValue) => {
    // normalize newlines to prevent duplication
    const normalized = newValue.replace(/\r\n/g, "\n");
    setEditForm(prev => ({ ...prev, content: normalized }));
  }}
  rows="4"
  style={{
    control: {
      minHeight: 80,
      borderRadius: 8,
      outline: "none",
    },
    highlighter: {
      padding: 6,
      fontSize: "clamp(12px, 1.8vmax, 18px)",
      lineHeight: 1.4,
    },
    input: {
      padding: 6,
      fontSize: "clamp(12px, 1.8vmax, 18px)",
      lineHeight: 1.4,
      color: "silver",
      background: "rgb(35, 30, 30)",
      boxShadow: "0px 0px 8px silver",
      border: "none",
      outline: "none",
    },
    suggestions: {
      list: {
        background: "rgb(35, 30, 30)",
        padding: 4,
        boxShadow: "0 0 8px rgba(255,255,255,0.3)",
        maxHeight: 200,
        overflowY: "auto",
      },
      item: {
        padding: "2px 6px",
        color: "white",
      },
    },
  }}
>
  <Mention
    trigger="@"
    data={usersList}
    displayTransform={(id, display) => `@${display}`}
    renderSuggestion={(entry, search, focused) => {
      const escapedDisplay = entry.display
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      const regex = new RegExp(`(${search})`, "ig");
      const finalHTML = escapedDisplay.replace(
        regex,
        `<span style="font-size: clamp(12px, 1.8vmax, 18px);">$1</span>`
      );

      return (
        <div
         style={{
                  color: focused ? "silver" : "silver",
                  backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                  fontSize: "clamp(12px, 1.8vmax, 18px)",
                  lineHeight: "1.1em",
                  zIndex: 2000,
                }}
          dangerouslySetInnerHTML={{ __html: finalHTML }}
        />
      );
    }}
  />
</MentionsInput>
      <label style={{ alignItems: "center", gap: "8px", cursor: "pointer" }}>
          {/* Icon triggers the hidden file input */}
          <ImageIcon color="silver" size={24} />

          <input
            type="file"
            accept="image/*"
             onChange={(e) =>
            setEditForm({
              ...editForm,
              image: e.target.files[0],
              removeImage: false,
            })
          }
            style={{ display: "none" }} // hide the actual input
          />
        </label>


        {/* <label style={{ alignItems: "center", gap: "8px", cursor: "pointer" }}>
          <FileText color="silver" size={24} />

          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            onChange={(e) =>
              setEditForm(prev => ({
                ...prev,
                doc: e.target.files[0],
                removeDoc: false,
              }))
            }
            style={{ display: "none" }}
          />
        </label> */}
   

     {/* Edit POST Emoji Picker */}
        <Button
          variant="none"
          size="m"
          onClick={() => setShowEditPostPicker((prev) => !prev)}
        >
          😀
        </Button>

        {showEditPostPicker && (
          <div
            ref={editPostPickerRef}
            className="emoji-picker-popover"
          >
            <button
              type="button"                 
            className="hover-brighten"
            style={{
              position: "absolute",
              bottom: -1,
              right: -1,
              zIndex: 2000,
              background: "red",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px", 
            }}
              onClick={() => setShowEditPostPicker(false)}
            >
            <b>Close</b>
            </button>

            <EmojiPicker
              variant="dark"
              onEmojiClick={(emojiData) => {
                setEditForm(prev => ({
                  ...prev,
                  content: prev.content + emojiData.emoji,
                }));
                editPostInputRef.current?.focus();
              }}
            />
          </div>
        )}
   {/* <Button
    type="button"
    onClick={() =>
      toggleBold(setEditForm, editPostInputRef)
    }
    style={{ background: "none", border: "none", cursor: "pointer" }}
    >
      <b style={{ fontSize: "1.2rem" }}>B</b>
    </Button>
    <Button
      type="button"
      onClick={() => toggleLink(setEditForm, editPostInputRef)}
      style={{ background: "none", border: "none", cursor: "pointer", fontSize: "clamp(1.2rem, 2vw, 1.8rem)", }}
    >
      🔗
    </Button> */}

    {/* <Button
  type="button"
  onClick={() => toggleItalic(setEditForm, editPostInputRef)}
  style={{ background: "none", border: "none", cursor: "pointer" }}
>
  <i style={{ fontSize: "1.2rem" }}>I</i>
</Button> */}

  {(editForm.existingImage || editForm.image || editForm.doc || editForm.existingDoc) && (
  <div
    style={{
      marginTop: "10px",
      display: "flex",
      flexDirection: "column", // stack children vertically
      alignItems: "center",
      position: "relative",
      gap: "30px", // spacing between image and doc button
    }}
  >
    {/* Image with X button */}
    {(editForm.existingImage || editForm.image) && (
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          src={
            editForm.image
              ? URL.createObjectURL(editForm.image)
              : editForm.existingImage
          }
          style={{
            maxWidth: "200px",
            maxHeight: "200px",
            borderRadius: "8px",
            objectFit: "cover",
            boxShadow: "0 0 8px silver",
          }}
        />
        <button
          type="button"
          onClick={() =>
            setEditForm({
              ...editForm,
              image: null,
              existingImage: "",
              removeImage: true,
            })
          }
          style={{
            position: "absolute",
            top: "-8px",
            right: "-8px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            cursor: "pointer",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ✕
        </button>
      </div>
    )}

    {/* Remove Document Button */}
    {(editForm.doc || editForm.existingDoc) && (
      <Button className="hover-brighten"
        type="button"
        onClick={() =>
          setEditForm(prev => ({
            ...prev,
            doc: null,
            existingDoc: "",
            removeDoc: true,
          }))
        }
        style={{
          fontWeight: "bold",
          color: "silver",
          display: "inline-block",
          backgroundColor: "rgba(20,19,19,0.9)",
          borderRadius: "12px",
          border: "2px solid rgb(179,37,25)",
          boxShadow: "0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)",
          padding: "6px 12px",
          cursor: "pointer",
        }}
      >
        <h2
        className='d-flex justify-content-center'
          style={{
                margin: '1%',
              }}
        >Remove Attachment</h2>
        
      </Button>
    )}
  </div>
)}




    {/* <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}> */}
      <button className="hover-brighten"
      type="submit"
      style={{
        background: "none", 
        border: "none", 
        cursor: "pointer",
        fontWeight: 'bold',
      }}
      >
        <p>Save</p>
      </button>
      <button className="hover-brighten"
        type="button"
         style={{
        background: "none", 
        border: "none", 
        cursor: "pointer",
        fontWeight: 'bold',
      }}
        onClick={() => setEditingPostId(null)}
      >
        <p>Cancel</p>
       
      </button>
    {/* </div> */}
    
  </form>
  </>
) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            
            
          }}
        >
          <h3 style={{ marginBottom: "5px", textAlign: "center", marginTop: "2px"  }}>
            {post.title}
          </h3>

<p

ref={(el) => (contentRefs.current[post.postId] = el)}
  style={{
    justifyContent: 'center',
    marginBottom: "2%",
    marginRight: '2%',
    marginLeft: '3%',
    marginTop: "2px",
     whiteSpace: "pre-wrap",

     display: "-webkit-box",
    WebkitLineClamp: isExpanded ? "unset" : 5,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }}
>
  {post.content.split(/(\*\*.*?\*\*|\[(?:.*?)\]\(https?:\/\/[^\s)]+\)|https?:\/\/[^\s]+|www\.[^\s]+|\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|@\[(?:.*?)\]\(.*?\))/g).map((part, i) => {
    if (!part) return null;

    // 🔹 Handle mentions
    const mentionMatch = part.match(/@\[(.*?)\]\((.*?)\)/);
    if (mentionMatch) {
      const [, name, userId] = mentionMatch;
      return (
        <a
          key={i}
          className="name-mention"
          
        >
          @{name}
        </a>
      );
    }

    

    // 🔹 Handle URLs
const cleanedPart = part.trim().replace(/[),.!?]+$/, "");

const emailRegex =
  /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

const emailMatch = cleanedPart.match(emailRegex);

if (emailMatch) {
  const email = emailMatch[0];
  const before = cleanedPart.slice(0, emailMatch.index);
  const after = cleanedPart.slice(emailMatch.index + email.length);

  return (
    <React.Fragment key={i}>
      {before}
      <a
        href={`mailto:${email}`}
        style={{ wordBreak: "break-word" }}
      >
        {email}
      </a>
      {after}
    </React.Fragment>
  );
}

// 🔹 Hyperlink renderer (supports markdown links AND raw URLs)

// 🔹 Hyperlink renderer (safe markdown + raw URL support)

const markdownLinkMatch = part.match(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/);

const urlMatch = part.match(
  /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g
);

// 1️⃣ Markdown hyperlink format [text](url)
if (markdownLinkMatch) {
  const [, text, url] = markdownLinkMatch;

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {text}
    </a>
  );
}

// 2️⃣ Raw URLs
if (urlMatch) {
  const url = urlMatch[0];

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {url}
    </a>
  );
}
// 🔹 Handle bold **text** and nested italics
const boldRegex = /\*\*(.*?)\*\*/;
const boldSegments = part.split(boldRegex);

if (boldSegments.length > 1) {
  return (
    <React.Fragment key={i}>
      {boldSegments.map((segment, idx) =>
        idx % 2 === 1 ? (
          <strong key={`${i}-bold-${idx}`}>{segment}</strong>
        ) : (
          // ✅ Recursively handle italics inside non-bold segments
          segment.split(/(\*|_)(.*?)\1/).map((subSeg, subIdx) =>
            subIdx % 3 === 2 ? (
              <em key={`${i}-italic-${subIdx}`}>{subSeg}</em>
            ) : (
              <React.Fragment key={`${i}-text-${subIdx}`}>
                {subSeg}
              </React.Fragment>
            )
          )
        )
      )}
    </React.Fragment>
  );
}


// 🔹 Normal text fallback
return <span key={i}>{part}</span>;
  })}

  
</p>

{isOverflowing && (
  <Button
    onClick={(e) => {
      e.stopPropagation(); // prevent parent toggle
      setExpandedPosts((prev) => ({
        ...prev,
        [post.postId]: !prev[post.postId],
      }));
    }}
  style={{ 
            background: "none", 
            border: "none", 
            color: "silver", 
            cursor: "pointer",
          fontWeight: "bold",  }}
  >
    <p>
      {isExpanded ? "See less" : "See more..."}
    </p>
  </Button>
)}


        {post.image && (
          <div style={{ textAlign: "center" }}>
            <img
              src={post.image} // this should be the URL returned from backend
              alt="Post attachment"
              style={{ maxWidth: "50%", borderRadius: "8px" }}
            />
          </div>
        )}

        {post.doc && (
  <div style={{ textAlign: "center", marginTop: "30px" }}>
    <Button className="hover-brighten"
      type="button"
      onClick={() => window.open(post.doc, "_blank", "noopener,noreferrer")}
       style={{
          fontWeight: "bold",
          color: "silver",
            display: "inline-block",
          // padding: "0.2rem 0.6rem",
          backgroundColor: 'rgba(20,19,19,0.9)',
          borderRadius: '12px',
          border: '2px solid rgb(179,37,25)',
          boxShadow: '0 0 5px rgba(243,174,61,0.6), 0 0 10px rgba(243,174,61,0.35)',
        }}
    >
      <h2 className='d-flex justify-content-center'
          style={{
                margin: '1%',
              }}
      >Open Attachment</h2>
      
    </Button>
  </div>
)}

           {currentUserId && post.userId === currentUserId && (
        <button className="hover-brighten"
          onClick={(e) => {
            e.stopPropagation(); // prevents open/close toggle
            startEditPost(post);
          }}
          style={{
            background: "none",
            border: "none",
            color: "silver",
            cursor: "pointer",
            marginTop: "15px",
            fontWeight: 'bold',
          }}
        >
          <p
          margin='0%'
          >Edit Post</p>
        </button>
      )}

      {currentUserId === "4a7d10ad-ce5c-4544-9f1a-e404a23aa16b" && (
  <button
    className="hover-brighten"
    onClick={(e) => {
      e.stopPropagation();
      handleTogglePin(post.postId);
    }}
    style={{
      background: "none",
      border: "none",
      color: post.pinned ? "gold" : "silver",
      cursor: "pointer",
      fontWeight: "bold",
    }}
  >
    <p>
      {post.pinned ? "Unpin Post 📌" : "Pin Post 📌"}
    </p>
  </button>
)}

        </div>
      )}

      
  <div

>
<PostActionBar
  key={post.postId}
  post={post}
  onReact={handleReact} // parent handles backend
  onOpenComments={openCommentsHandler}
  onShare={shareHandler}
/>


</div>

    </div>

    

 {/* Comments and form hidden inside Collapse */}
<Collapse in={openPosts[post.postId] === true}>

  <div 
  style={{ 
    margin: "10px" 
  }}
  >
    <h4>Comments</h4>
    
    {post.comments.length > 0 ? post.comments.map(c => {

      const cid = c.commentId;
      // Recursive function to render replies inline


      const renderReplies = (replies, depth = 0) => {
        if (!replies || replies.length === 0) return null;
        
         const visualDepth = Math.min(depth, MAX_DEPTH);
  

  return (
    <>
      {replies.map(r => (
        
        <div key={r.replyId} 
        id={`post-${post.postId}-comment-${c.commentId}-reply-${r.replyId}`}
        className="reply-container"
        style={{ marginLeft: `${visualDepth * 16}px` }}
        > 
          <div className="user-input-commented" style={{ flex: 1 }}>
            <div className="user-input-reply" style={{ marginRight: "5%", width: "100%", padding: "10px" }}>
                <div
                 style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                 >
              <img
                src={r.profileImage || "https://via.placeholder.com/35"}
                alt={r.postedBy || "Unknown User"}
                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
              />
              <b>{r.postedBy || r.userId}</b>
                 </div>
              {editingReply?.replyId === r.replyId? (
              <form
                onSubmit={(e) =>
                  handleUpdateReply(
                  e,
                  post.postId,
                  c.commentId,
                  editingReply.replyId,
                  editingReply.parentReplyId
                )

                }
                style={{ width: "100%" }}
              >
                <MentionsInput
                inputRef={el => (editNestedReplyInputRefs.current[r.replyId] = el)}
                  value={editReplyForm.content || ""}
                  onChange={(e) =>
                    setEditReplyForm({ content: e.target.value })
                  }
                  style={{
                  control: {
                    minHeight: 80,
                    borderRadius: 8,
                    outline: "none",
                  },
                  highlighter: {
                    padding: 6,
                    fontSize: "clamp(12px, 1.8vmax, 18px)",
                    lineHeight: 1.4,
                  },
                  input: {
                    padding: 6,
                    fontSize: "clamp(12px, 1.8vmax, 18px)",
                    lineHeight: 1.4,
                    color: "silver",
                    background: "rgb(35, 30, 30)",
                    boxShadow: "0px 0px 8px silver",
                    border: "none",
                    outline: "none",
                  },
                  suggestions: {
                    list: {
                      background: "rgb(35, 30, 30)",
                      padding: 4,
                      boxShadow: "0 0 8px rgba(255,255,255,0.3)",
                      maxHeight: 200,
                      overflowY: "auto",
                    },
                    item: {
                      padding: "2px 6px",
                      color: "white",
                    },
                  },
                }}
                  
                >
                  <Mention
                    trigger="@"
                    data={usersList}
                                      displayTransform={(id, display) => `@${display}`}
                  renderSuggestion={(entry, search, focused) => {
                    const escapedDisplay = entry.display
                      .replace(/&/g, "&amp;")
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;");

                    const regex = new RegExp(`(${search})`, "ig");
                    const finalHTML = escapedDisplay.replace(
                      regex,
                      `<span style="font-size: clamp(12px, 1.8vmax, 18px);">$1</span>`
                    );

                    return (
                      <div
                      style={{
                                color: focused ? "silver" : "silver",
                                backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                                fontSize: "clamp(12px, 1.8vmax, 18px)",
                                lineHeight: "1.1em",
                                zIndex: 2000,
                              }}
                        dangerouslySetInnerHTML={{ __html: finalHTML }}
                      />
                    );
                  }}
                  />
                </MentionsInput>
                 <Button
                  variant="none"
                  size="m"
                  onClick={() =>
                    setShowEditNestedReplyPickers(prev => ({
                      ...prev,
                      [r.replyId]: !prev[r.replyId],
                    }))
                  }

                >
                  😀
                </Button>
                {showEditNestedReplyPickers[r.replyId] && (
                  <div
                    ref={el => (editNestedReplyPickerRefs.current[r.replyId] = el)}
                    className="emoji-picker-popover"
                  >
                    <button
                      type="button"                 
                    className="hover-brighten"
                    style={{
                      position: "absolute",
                      bottom: -1,
                      right: -1,
                      zIndex: 2000,
                      background: "red",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: "4px", 
                    }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowEditNestedReplyPickers(prev => ({
                          ...prev,
                          [r.replyId]: false,
                        }));
                      }}

                    >
                    <b>Close</b>
                    </button>

                  <EmojiPicker
                    variant="dark"
                  onEmojiClick={(emojiData) => {
                    setEditReplyForm(prev => ({
                      ...prev,
                      content: (prev.content || "") + emojiData.emoji,
                    }));

                    editNestedReplyInputRefs.current[r.replyId]?.focus();
                  }}

                  />
                    </div>
                  )}

                 <button className="hover-brighten"
                type="submit"
                style={{
                  background: "none", 
                  border: "none", 
                  cursor: "pointer",
                  fontWeight: 'bold',
                }}
                >
                  <p>Save</p>
                </button>
                  <button className="hover-brighten"
                  type="button"
                    style={{
                    background: "none", 
                    border: "none", 
                    cursor: "pointer",
                    fontWeight: 'bold',
                  }}
                  onClick={() => setEditingReply(null)}
                >
                  <p>Cancel</p>
                </button>
              </form>
            ) : (
            <p style={{ margin: "4px 0" }}>
             {r.content.split(LINK_REGEX).map((part, i) => {
              if (!part) return null;

              // 🔹 Handle mentions
              const mentionMatch = part.match(/@\[(.*?)\]\((.*?)\)/);
              if (mentionMatch) {
                const [, name, userId] = mentionMatch;
                return (
                  <a
                    key={i}
                    className="name-mention"
                    
                  >
                    @{name}
                  </a>
                );
              }

    // 🔹 Handle URLs
const cleanedPart = part.trim().replace(/[),.!?]+$/, "");

const emailRegex =
  /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

const emailMatch = cleanedPart.match(emailRegex);

if (emailMatch) {
  const email = emailMatch[0];
  const before = cleanedPart.slice(0, emailMatch.index);
  const after = cleanedPart.slice(emailMatch.index + email.length);

  return (
    <React.Fragment key={i}>
      {before}
      <a
        href={`mailto:${email}`}
        style={{ wordBreak: "break-word" }}
      >
        {email}
      </a>
      {after}
    </React.Fragment>
  );
}

// 🔹 Hyperlink renderer (supports markdown links AND raw URLs)

// 🔹 Hyperlink renderer (safe markdown + raw URL support)

const markdownLinkMatch = part.match(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/);

const urlMatch = part.match(
  /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g
);

// 1️⃣ Markdown hyperlink format [text](url)
if (markdownLinkMatch) {
  const [, text, url] = markdownLinkMatch;

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {text}
    </a>
  );
}

// 2️⃣ Raw URLs
if (urlMatch) {
  const url = urlMatch[0];

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {url}
    </a>
  );
}
// 🔹 Handle bold **text**
const boldRegex = /\*\*(.*?)\*\*/;

const boldSegments = part.split(boldRegex);

if (boldSegments.length > 1) {
  return (
    <React.Fragment key={i}>
      {boldSegments.map((segment, idx) =>
        idx % 2 === 1 ? (
          <strong key={`${i}-bold-${idx}`}>{segment}</strong>
        ) : (
          <React.Fragment key={`${i}-text-${idx}`}>
            {segment}
          </React.Fragment>
        )
      )}
    </React.Fragment>
  );
}
    // 🔹 Normal text
    return <span key={i}>{part}</span>;
  })}
            
            </p>
              )}
      {currentUserId &&
        r.userId === currentUserId &&
        editingReply?.replyId !== r.replyId && (
          <button
            className="hover-brighten"
            onClick={() => startEditReply(r)}
            style={{
              background: "none",
              border: "none",
              color: "silver",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            <p style={{ margin: 0 }}>Edit Reply</p>
          </button>
        )}
            </div>
            {/* Reply button */}
            <button type="button" onClick={() => toggleReply(r.replyId)} 
            style={{ 
              background: "none", 
              border: "none", 
              cursor: "pointer", 
              padding: 0, 
              marginLeft: "3%" }}>
              <b>Reply</b>
            </button>

            {/* View Replies button (only if there are child replies) */}
            {r.replies?.length > 0 && (
              <button
                type="button"
                onClick={() => toggleReplies(r.replyId)}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "0.9rem", padding: 0, marginLeft: "5%" }}
              >
                <b>
                  {visibleReplies[r.replyId] ? "Hide Replies" : `View Replies (${r.replies.length})`}
                </b>
              </button>
            )}

            {/* Inline reply form */}
          {replyForms[r.replyId]?.open && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitReply(post.postId, r.replyId);
            }}
             style={{
              display: "flex",
              flexDirection: "column", // stack children vertically
              gap: "6px",
              marginTop: "6px",
              position: "relative", // needed for absolute emoji picker
            }}
          >
            {replyErrors[r.replyId] && (
            <div className="reply-error"
              style={{
                fontSize: "16px",
                marginTop: "4px",
              }}
            >
              {replyErrors[r.replyId]}
            </div>
          )}
            <MentionsInput
              value={replyForms[r.replyId]?.text || ""}
              onChange={(e) => {
                handleReplyChange(r.replyId, e.target.value);
                setReplyErrors(prev => ({ ...prev, [r.replyId]: "" }));
              }}
              rows="4"
              placeholder="Write a reply..."
              style={{
              control: {
                minHeight: 40,
                borderRadius: 8,
                background: "rgb(35, 30, 30)",
                boxShadow: "0px 0px 8px silver",
                border: "none",
                padding: 6,
                width: "100%",
              },
                highlighter: {
                  padding: 6,
                  fontSize: 16,
                  lineHeight: 1.4,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  display: "block",       // <-- force wrapping
                  width: "100%",          // <-- fill container
                },

                input: {
                  padding: 6,
                  fontSize: 16,
                  lineHeight: 1.4,
                  color: "silver",
                  background: "rgb(35, 30, 30)",
                  border: "none",
                  outline: "none",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  display: "block",       // <-- force wrapping
                  width: "100%",          // <-- fill container
                },
                suggestions: {
                  list: {
                    background: "rgb(35, 30, 30)",
                    padding: 4,
                    boxShadow: "0 0 8px rgba(255,255,255,0.3)",
                    border: 'none',
                    maxHeight: 200,      // <-- This limits the height of the dropdown
                    overflowY: "auto",
                  },
                  item: {
                    padding: "2px 6px",
                    color: "white",
                  },
                },
              }}
   
            >
              <Mention
                trigger="@"
                data={usersList}
                displayTransform={(id, display) => `@${display}`}
                    renderSuggestion={(entry, search, focused) => {
            // Escape the HTML safely to avoid XSS
            const escapedDisplay = entry.display.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

            // Highlight the matching letters manually
            const regex = new RegExp(`(${search})`, "ig");
            const finalHTML = escapedDisplay.replace(regex, `<span style="font-size: 16px; line-height: 1.5em;">$1</span>`);

            return (
              <div
                style={{
                 
                  color: focused ? "silver" : "silver",
                  backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                  fontSize: 16,
                  lineHeight: "1.5em",
                  
                }}
                // Render the highlighted letters correctly
                dangerouslySetInnerHTML={{ __html: finalHTML }}
              />
            );
          }}
              />
            </MentionsInput>
          <div style={{ display: "flex", gap: "6px", alignItems: "center", position: "relative" }}>
        {/* NESTED REPLY Emoji Picker */}
        <Button
          variant="none"
          size="m"
          onClick={() =>
            setShowNestedReplyPickers(prev => ({
              ...prev,
              [r.replyId]: !prev[r.replyId],
            }))
          }
        >
          😀
        </Button>

        <div
          className="emoji-picker-popover"
          ref={el => (nestedReplyPickerRefs.current[r.replyId] = el)}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 1000,
            display: showNestedReplyPickers[r.replyId] ? "block" : "none",
          }}
        >
          {/* Close button */}
          <button
            type="button"                 
            className="hover-brighten"
            style={{
              position: "absolute",
              bottom: -1,
              right: -1,
              zIndex: 2000,
              background: "red",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px", 
            }}
            onClick={(e) => {
              e.stopPropagation();        // ⬅️ PREVENT bubbling
              setShowNestedReplyPickers(prev => ({
                ...prev,
                [r.replyId]: false,
              }));
            }}
          >
            <b>Close</b>
          </button>

          <EmojiPicker
            variant="dark"
            onEmojiClick={(emojiData) => {
              setReplyForms(prev => ({
                ...prev,
                [r.replyId]: {
                  ...prev[r.replyId],
                  text: (prev[r.replyId]?.text || "") + emojiData.emoji,
                },
              }));
              nestedReplyInputRefs.current[r.replyId]?.focus();
            }}
          />
        </div>

          <button
            type="submit" 
            className="send-button"
            disabled={replySubmitting[r.replyId]}
            style={{ 
              background: "none", 
              border: "none", 
              cursor: replySubmitting[r.replyId] ? "not-allowed" : "pointer",
              opacity: replySubmitting[r.replyId] ? 0.5 : 1, 
            }}
          >
            <FaPaperPlane className="send-icon" 
            style={{ 
              fontSize: "1.4rem", 
              color: "white" }} />
          </button>
        </div>
              </form>
            )}
                {/* Render child replies only if visible */}
                {r.replies?.length > 0 && visibleReplies[r.replyId] && renderReplies(r.replies, depth)}
              </div>
            </div>
          ))}
        </>
      );
    };

    return (
      <div 
        key={c.commentId}
        id={`post-${post.postId}-comment-${c.commentId}`}
        style={{ display: "flex", gap: "10px", marginBottom: "12px" }}
      >
     
        <div className="user-input-commented" style={{ flex: 1 }}>
          
          <div
            className="user-input-reply"
            style={{ marginRight: '5%', width: "100%", height: "auto", padding: '10px' }}
          >
            <div
                 style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                 >
               <img
          src={c.profileImage || "https://via.placeholder.com/50"}
          alt={c.postedBy || c.userId || "Unknown User"}
          style={{ width: "30px", height: "30px", borderRadius: "50%" }}
        />
            <b>{c.postedBy || c.userId || "Unknown"}</b>
            </div>

        {editingCommentId === c.commentId ? (
          <>
          {console.log("COMMENT EDITOR RENDER")}
            <form
              onSubmit={(e) => handleUpdateComment(e, post.postId, c.commentId)}
              style={{ width: "100%" }}
            >
              <MentionsInput
                inputRef={(el) => (editCommentInputRef.current[c.commentId] = el)}
                value={editCommentForm.comment || ""}
                onChange={(e) =>
                  setEditCommentForm({ ...editCommentForm, comment: e.target.value })
                }
                  style={{
                  control: {
                    minHeight: 80,
                    borderRadius: 8,
                    outline: "none",
                  },
                  highlighter: {
                    padding: 6,
                    fontSize: "clamp(12px, 1.8vmax, 18px)",
                    lineHeight: 1.4,
                  },
                  input: {
                    padding: 6,
                    fontSize: "clamp(12px, 1.8vmax, 18px)",
                    lineHeight: 1.4,
                    color: "silver",
                    background: "rgb(35, 30, 30)",
                    boxShadow: "0px 0px 8px silver",
                    border: "none",
                    outline: "none",
                  },
                  suggestions: {
                    list: {
                      background: "rgb(35, 30, 30)",
                      padding: 4,
                      boxShadow: "0 0 8px rgba(255,255,255,0.3)",
                      maxHeight: 200,
                      overflowY: "auto",
                    },
                    item: {
                      padding: "2px 6px",
                      color: "white",
                    },
                  },
                }}
              >
                <Mention 
                  trigger="@"
                  data={usersList}
                  displayTransform={(id, display) => `@${display}`}
                  renderSuggestion={(entry, search, focused) => {
                    const escapedDisplay = entry.display
                      .replace(/&/g, "&amp;")
                      .replace(/</g, "&lt;")
                      .replace(/>/g, "&gt;");

                    const regex = new RegExp(`(${search})`, "ig");
                    const finalHTML = escapedDisplay.replace(
                      regex,
                      `<span style="font-size: clamp(12px, 1.8vmax, 18px);">$1</span>`
                    );

                    return (
                      <div
                      style={{
                                color: focused ? "silver" : "silver",
                                backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                                fontSize: "clamp(12px, 1.8vmax, 18px)",
                                lineHeight: "1.1em",
                                zIndex: 2000,
                              }}
                        dangerouslySetInnerHTML={{ __html: finalHTML }}
                      />
                    );
                  }}
                />
              </MentionsInput>


        <Button
          variant="none"
          size="m"
          onClick={() => setShowEditCommentPicker((prev) => !prev)}
        >
          😀
        </Button>

        {showEditCommentPicker && (
          <div
            ref={editCommentPickerRef}
            className="emoji-picker-popover"
          >
            <button
              type="button"                 
            className="hover-brighten"
            style={{
              position: "absolute",
              bottom: -1,
              right: -1,
              zIndex: 2000,
              background: "red",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px", 
            }}
              onClick={() => setShowEditCommentPicker(false)}
            >
            <b>Close</b>
            </button>

          <EmojiPicker
            variant="dark"
            onEmojiClick={(emojiData) => {
              setEditCommentForm(prev => ({
                ...prev,
                comment: (prev.comment || "") + emojiData.emoji,
              }));

              editCommentInputRef.current[c.commentId]?.focus();
            }}
          />
            </div>
          )}
              <button className="hover-brighten"
                type="submit"
                style={{
                  background: "none", 
                  border: "none", 
                  cursor: "pointer",
                  fontWeight: 'bold',
                }}
                >
                  <p>Save</p>
                </button>
                 <button className="hover-brighten"
                  type="button"
                    style={{
                    background: "none", 
                    border: "none", 
                    cursor: "pointer",
                    fontWeight: 'bold',
                  }}
                  onClick={() => setEditingCommentId(null)}
                >
                  <p>Cancel</p>
                </button>

            </form>
             </>
          ) : (
            <p style={{ margin: "4px 0" }}>
             {c.comment.split(LINK_REGEX).map((part, i) => {
              if (!part) return null;

              // 🔹 Handle mentions
              const mentionMatch = part.match(/@\[(.*?)\]\((.*?)\)/);
              if (mentionMatch) {
                const [, name, userId] = mentionMatch;
                return (
                  <a
                    key={i}
                    className="name-mention"
                    
                  >
                    @{name}
                  </a>
                );
              }
    // 🔹 Handle URLs
const cleanedPart = part.trim().replace(/[),.!?]+$/, "");

const emailRegex =
  /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

const emailMatch = cleanedPart.match(emailRegex);

if (emailMatch) {
  const email = emailMatch[0];
  const before = cleanedPart.slice(0, emailMatch.index);
  const after = cleanedPart.slice(emailMatch.index + email.length);

  return (
    <React.Fragment key={i}>
      {before}
      <a
        href={`mailto:${email}`}
        style={{ wordBreak: "break-word" }}
      >
        {email}
      </a>
      {after}
    </React.Fragment>
  );
}

// 🔹 Hyperlink renderer (supports markdown links AND raw URLs)

// 🔹 Hyperlink renderer (safe markdown + raw URL support)

const markdownLinkMatch = part.match(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/);

const urlMatch = part.match(
  /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g
);

// 1️⃣ Markdown hyperlink format [text](url)
if (markdownLinkMatch) {
  const [, text, url] = markdownLinkMatch;

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {text}
    </a>
  );
}

// 2️⃣ Raw URLs
if (urlMatch) {
  const url = urlMatch[0];

  return (
    <a
      key={i}
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-word" }}
    >
      {url}
    </a>
  );
}
// 🔹 Handle bold **text**
const boldRegex = /\*\*(.*?)\*\*/;

const boldSegments = part.split(boldRegex);

if (boldSegments.length > 1) {
  return (
    <React.Fragment key={i}>
      {boldSegments.map((segment, idx) =>
        idx % 2 === 1 ? (
          <strong key={`${i}-bold-${idx}`}>{segment}</strong>
        ) : (
          <React.Fragment key={`${i}-text-${idx}`}>
            {segment}
          </React.Fragment>
        )
      )}
    </React.Fragment>
  );
}
    // 🔹 Normal text
    return <span key={i}>{part}</span>;
  })}
            </p>
            )}

            {currentUserId &&
          c.userId === currentUserId &&
          editingCommentId !== c.commentId && (
            <button
              className="hover-brighten"
              onClick={() => startEditComment(c)}
              style={{
                background: "none",
                border: "none",
                color: "silver",
                cursor: "pointer",
                fontWeight: 'bold',
              }}
            >
              <p margin="0%">Edit Comment</p>
            </button>
          )}

          </div>

        {/* Reply button */}
        <button
          type="button"
          onClick={() => toggleReply(cid)}
          style={{ background: "none", border: "none", cursor: "pointer", padding: 0, marginLeft: "3%" }}
        >
          <b>Reply</b>
        </button>
             {/* VIEW REPLIES button for top-level comment */}
        {c.replies?.length > 0 && (
          <button
            type="button"
            onClick={() => toggleReplies(cid)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0, marginLeft: "5%", marginTop: "4px" }}
          >
            <b>
              {visibleReplies[cid] ? "Hide Replies" : `View Replies (${c.replies.length})`}
            </b>
          </button>
        )}
             {replyErrors[cid] && (
              <div className="reply-error"
                style={{
                  fontSize: "16px",
                  marginTop: "4px",
                }}
              >
                {replyErrors[cid]}
              </div>
            )}

        {/* Inline reply form */}
        {replyForms[cid]?.open && (
          
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitReply(post.postId, cid);
            }}
              style={{
              display: "flex",
              flexDirection: "column", // stack children vertically
              gap: "6px",
              marginTop: "6px",
              position: "relative", // needed for absolute emoji picker
            }}
          >

            <MentionsInput
              value={replyForms[cid]?.text || ""}
              onChange={(e) => {
                handleReplyChange(cid, e.target.value);
                setReplyErrors(prev => ({ ...prev, [cid]: "" }));
              }}
              // className="form-control"
              rows="4"
              placeholder="Write a reply..."
              style={{
                control: {
                  minHeight: 40,
                  borderRadius: 8,
                  outline: "none",
                  background: "rgb(35, 30, 30)",
                  boxShadow: "0px 0px 8px silver",
                  border: "none",
                  padding: 6,
                  width: "100%",
                },
                highlighter: {
                  padding: 6,
                  fontSize: 16,
                  lineHeight: 1.4,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  display: "block",       // <-- force wrapping
                  width: "100%",          // <-- fill container
                },
                input: {
                  padding: 6,
                  fontSize: 16,
                  lineHeight: 1.4,
                  color: "silver",
                  background: "rgb(35, 30, 30)",
                  border: "none",
                  outline: "none",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  display: "block",       // <-- force wrapping
                  width: "100%",          // <-- fill container
                },
                suggestions: {
                  list: {
                     background: "rgb(35, 30, 30)",
                      padding: 4,
                      boxShadow: "0 0 8px rgba(255,255,255,0.3)",
                      border: 'none',
                      maxHeight: 200,      // <-- This limits the height of the dropdown
                      overflowY: "auto",
                  },
                  item: {
                    padding: "2px 6px",
                    color: "white",
                  },
                },
              }}
  
            >
              <Mention
                trigger="@"
                data={usersList}
                displayTransform={(id, display) => `@${display}`}
                   renderSuggestion={(entry, search, focused) => {
            // Escape the HTML safely to avoid XSS
            const escapedDisplay = entry.display.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

            // Highlight the matching letters manually
            const regex = new RegExp(`(${search})`, "ig");
            const finalHTML = escapedDisplay.replace(regex, `<span style="font-size: 16px; line-height: 1.5em;">$1</span>`);

            return (
              <div
                style={{
                
                  color: focused ? "silver" : "silver",
                  backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                  fontSize: 16,
                  lineHeight: "1.5em",
                  
                }}
                // Render the highlighted letters correctly
                dangerouslySetInnerHTML={{ __html: finalHTML }}
              />
            );
          }}
              />
            </MentionsInput>


            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>

            {/* REPLY Emoji Picker */}
            <Button
              variant="none"
              size="m"
              onClick={() =>
                setShowReplyPickers(prev => ({
                  ...prev,
                  [cid]: !prev[cid],
                }))
              }
            >
              😀
            </Button>

            <div
              className="emoji-picker-popover"
              ref={el => (replyPickerRefs.current[cid] = el)}
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                zIndex: 1000,
                display: showReplyPickers[cid] ? "block" : "none",
              }}
            >
              {/* Close button */}
            <button
              type="button"             // <-- prevent form submission
              className="hover-brighten"
              style={{
                position: "absolute",
                bottom: -1,
                right: -1,
                zIndex: 2000,
                background: "red",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px", 
              }}
              onClick={(e) => {
                e.stopPropagation();     // prevent click from bubbling
                setShowReplyPickers(prev => ({
                  ...prev,
                  [cid]: false,
                }));
              }}
            >
              <b>Close</b>
            </button>


              <EmojiPicker
                variant="dark"
                onEmojiClick={(emojiData) => {
                  setReplyForms(prev => ({
                    ...prev,
                    [cid]: {
                      ...prev[cid],
                      text: (prev[cid]?.text || "") + emojiData.emoji,
                    },
                  }));
                  replyInputRefs.current[cid]?.focus();
                }}
              />
            </div>

            <button
              type="submit"
              className="send-button" 
              disabled={replySubmitting[cid]}
              style={{ 
                background: "none", 
                border: "none", 
                cursor: replySubmitting[cid] ? "not-allowed" : "pointer",
                opacity: replySubmitting[cid] ? 0.5 : 1,
               }}
            >
              <FaPaperPlane className="send-icon" 
               style={{ 
                fontSize: "1.4rem", 
                color: "white" }} />
            </button>
            </div>
          </form>
        )}

        {/* Render child replies only if visible */}
        {c.replies?.length > 0 && visibleReplies[cid] && renderReplies(c.replies, 1)}
      </div>
    </div>
  );
}) 

: (
  <p>No comments yet.</p>
)}

        {/* Main post comment form unchanged */}
           {commentErrors[post.postId] && (
            <div
              style={{
                color: "#ff4d4f",
                fontSize: "16px",
                marginBottom: "4px",
              }}
            >
              {commentErrors[post.postId]}
            </div>
          )}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmitComment(post.postId);
          }}
            style={{
            display: "flex",
            flexDirection: "column", // stack children vertically
            gap: "6px",
            marginTop: "6px",
            position: "relative", // needed for absolute emoji picker
          }}
        >

      

          <MentionsInput
            value={commentForms[post.postId]?.comment || ""}
           onChange={(e) => {
            setCommentForms({
              ...commentForms,
              [post.postId]: {
                ...commentForms[post.postId],
                comment: e.target.value,
              },
            });

            // 🔥 THIS WAS MISSING
            setCommentErrors(prev => ({
              ...prev,
              [post.postId]: "",
            }));
          }}
            placeholder="Add a comment..."
            // className="form-control"
            style={{
              control: {
                minHeight: 80,
                borderRadius: 8,
                outline: "none",
                background: "rgb(35, 30, 30)",
                boxShadow: "0px 0px 8px silver",
                border: "none",
              },
              highlighter: {
                padding: 6,
                fontSize: 16,
                lineHeight: 1.5,
              },
              input: {
                padding: 6,
                fontSize: 16,
                lineHeight: 1.5,
                color: "silver",
                background: "rgb(35, 30, 30)",
                border: "none",
                outline: "none",
              },
              suggestions: {
                list: {
                  background: "rgb(35, 30, 30)",
                  padding: 4,
                  boxShadow: "0 0 8px rgba(255,255,255,0.3)",
                  border: 'none',
                  maxHeight: 200,      // <-- This limits the height of the dropdown
                  overflowY: "auto",
                },
                item: {
                  padding: "2px 6px",
                  color: "white",
                },
              },
            }}

          >
            <Mention
          trigger="@"
          data={usersList}
          displayTransform={(id, display) => `@${display}`}
          renderSuggestion={(entry, search, focused) => {
            // Escape the HTML safely to avoid XSS
            const escapedDisplay = entry.display.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

            // Highlight the matching letters manually
            const regex = new RegExp(`(${search})`, "ig");
            const finalHTML = escapedDisplay.replace(regex, `<span style="font-size: 16px; line-height: 1.5em;">$1</span>`);

            return (
              <div
                style={{
                 
                  color: focused ? "silver" : "silver",
                  backgroundColor: focused ? "rgb(35, 30, 30)" : "transparent",
                  fontSize: 16,
                  lineHeight: "1.5em",
                  
                }}
                // Render the highlighted letters correctly
                dangerouslySetInnerHTML={{ __html: finalHTML }}
              />
            );
          }}
            />
          </MentionsInput>

           <div style={{ display: "flex", gap: "6px", alignItems: "center", position: "relative" }}>
          {/* COMMENT Emoji Picker */}
          <Button
            variant="none"
            size="m"
            onClick={() =>
              setShowCommentPickers(prev => ({
                ...prev,
                [post.postId]: !prev[post.postId],
              }))
            }
          >
            😀
          </Button>

          <div
            className="emoji-picker-popover"
            ref={el => (commentPickerRefs.current[post.postId] = el)}
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              zIndex: 1000,
              display: showCommentPickers[post.postId] ? "block" : "none",
            }}
          >
            {/* Close button */}
            <button
              type="button"                 // ✅ prevent form submission
              className="hover-brighten"
            style={{
                position: "absolute",
                bottom: -1,
                right: -1,
                zIndex: 2000,
                background: "red",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px", 
              }}
              onClick={(e) => {
                e.stopPropagation();        // ✅ prevent bubbling
                setShowCommentPickers(prev => ({
                  ...prev,
                  [post.postId]: false,
                }));
              }}
            >
              <b>Close</b>
            </button>

            <EmojiPicker
              variant="dark"
              onEmojiClick={(emojiData) => {
                setCommentForms(prev => ({
                  ...prev,
                  [post.postId]: {
                    ...prev[post.postId],
                    comment: (prev[post.postId]?.comment || "") + emojiData.emoji,
                  },
                }));
                commentInputRefs.current[post.postId]?.focus();
              }}
            />
          </div>
          <button
            type="submit"
            className="send-button"
            disabled={commentSubmitting[post.postId]} 
            style={{ 
              background: "none", 
              border: "none", 
              cursor: commentSubmitting[post.postId] ? "not-allowed" : "pointer",
              opacity: commentSubmitting[post.postId] ? 0.5 : 1,
             }}
          >
            <FaPaperPlane className="send-icon"  
            style={{ 
              fontSize: "1.4rem", 
              color: "white" }} />
          </button>
          </div>
        </form>
        </div>
      </Collapse>
      </Card>
     );
    })}
      </div>
    </>
  );
}

export default Submit;
